const state = {
  language: '',
  is_login: false,
  is_in_alert: false,
  show_drawer: true,
  show_modal: false,
  device_id: '',
  user_id: '',
  user_token: '',
  user_sections:{
    offers: false,
    rewards: false,
    favorites: false,
    invitations: false,
    room_bookings: false,
    locations: false,
    personal_trainer: false,
    news: false,
    events: false,
    company_connections: false,
    us: false,
    contact_us: false,
    inside_request: false
  },
  monitored_companies: [],
  selected_company: null,
  loader: false,
  email: '',
  selected_location: null,
  screen_orientation: 'landscape',
  show_phone_prompt: false,
  is_touch: false
}

const getters = {
  getUserToken (state) { return state.user_token },
  getDeviceId (state) { return state.device_id },
  getLanguage (state) { return state.language },
  getShowDrawer (state) { return state.show_drawer },
  getShowModal (state) { return state.show_modal },
  getValidationOffers (state) {return state.user_sections.offers},
  getValidationRewards (state) {return state.user_sections.rewards},
  getValidationFavorites (state) {return state.user_sections.favorites},
  getValidationInvitations (state) {return state.user_sections.invitations},
  getValidationRoomBookings (state) {return state.user_sections.room_bookings},
  getValidationLocations (state) {return state.user_sections.locations},
  getValidationPersonalTrainer (state) {return state.user_sections.personal_trainer},
  getValidationNews (state) {return state.user_sections.news},
  getValidationEvents (state) {return state.user_sections.events},
  getValidationCompanyConnections (state) {return state.user_sections.company_connections},
  getValidationUs (state) {return state.user_sections.us},
  getValidationContactUs (state) {return state.user_sections.contact_us},
  getValidationInsideRequest (state) {return state.user_sections.inside_request},
  getIsLogin(state) { return state.is_login },
  getIsInAlert(state) { return state.is_in_alert },
  getUserId(state) { return state.user_id },
  getMonitoredCompanies(state) { return state.monitored_companies },
  getSelectedCompany(state) { return state.selected_company },
  getLoader(state) { return state.loader },
  getEmail(state) { return state.email },
  getSelectedLocation(state) { return state.selected_location },
  getScreenOrientation(state) { return state.screen_orientation },
  getShowPhonePrompt(state) { return state.show_phone_prompt },
  getIsTouch(state) { return state.is_touch },
}

const mutations = {
  setLanguage(state, payload) { state.language = payload },
  setShowDrawer(state, payload) { state.show_drawer = payload },
  setShowModal(state, payload) { state.show_modal = payload },
  setCompany(state, payload) { state.company = payload },
  setUserToken(state, payload) { state.user_token = payload },
  setDeviceId(state, payload) { state.device_id = payload },
  setValidationOffers (state, payload) { state.user_sections.offers = payload},
  setValidationRewards (state, payload) { state.user_sections.rewards = payload},
  setValidationFavorites (state, payload) { state.user_sections.favorites = payload},
  setValidationInvitations (state, payload) { state.user_sections.invitations = payload},
  setValidationRoomBookings (state, payload) { state.user_sections.room_bookings = payload},
  setValidationLocations (state, payload) { state.user_sections.locations = payload},
  setValidationPersonalTrainer (state, payload) { state.user_sections.personal_trainer = payload},
  setValidationNews (state, payload) { state.user_sections.news = payload},
  setValidationEvents (state, payload) { state.user_sections.events = payload},
  setValidationCompanyConnections (state, payload) { state.user_sections.company_connections = payload},
  setValidationUs (state, payload) { state.user_sections.us = payload},
  setValidationContactUs (state, payload) { state.user_sections.contact_us = payload},
  setValidationInsideRequest (state, payload) { state.user_sections.inside_request = payload},
  setIsLogin: function(state, payload) { state.is_login = payload },
  setIsInAlert: function(state, payload) { state.is_in_alert = payload },
  setUserIdEncrypt: function (state, payload) {
    state.user_id_encrypt = payload
    sessionStorage.setItem('user_id_encrypt', payload)
  },
  setUserType(state, payload) { state.user_type = payload },
  setUserId(state, payload) { state.user_id = payload },
  setMonitoredCompanies(state, payload) { state.monitored_companies = payload },
  setSelectedCompany(state, payload) { state.selected_company = payload },
  setLoader(state, payload) { state.loader = payload },
  setEmail(state, payload) { state.email = payload },
  setSelectedLocation(state, payload) { state.selected_location = payload },
  setScreenOrientation(state, payload) { state.screen_orientation = payload },
  setShowPhonePrompt(state, payload) { state.show_phone_prompt = payload },
  setIsTouch(state, payload) { state.is_touch = payload },
}

const actions = {
  updateUserToken({commit}, payload) { commit('setUserToken', payload) },
  updateLanguage({commit}, payload) { commit('setLanguage', payload) },
  updateShowDrawer({commit}, payload) { commit('setShowDrawer', payload) },
  updateShowModal({commit}, payload) { commit('setShowModal', payload) },
  updateCompany({commit}, payload) { commit('setCompany', payload) },
  updateDeviceId({commit}, payload) { commit('setDeviceId', payload)  },
  updateValidationOffers ({commit}, payload) {commit('setValidationOffers', payload)},
  updateValidationRewards ({commit}, payload) {commit('setValidationRewards', payload)},
  updateValidationFavorites ({commit}, payload) {commit('setValidationFavorites', payload)},
  updateValidationInvitations ({commit}, payload) {commit('setValidationInvitations', payload)},
  updateValidationRoomBookings ({commit}, payload) {commit('setValidationRoomBookings', payload)},
  updateValidationLocations ({commit}, payload) {commit('setValidationLocations', payload)},
  updateValidationPersonalTrainer ({commit}, payload) {commit('setValidationPersonalTrainer', payload)},
  updateValidationNews ({commit}, payload) {commit('setValidationNews', payload)},
  updateValidationEvents ({commit}, payload) {commit('setValidationEvents', payload)},
  updateValidationCompanyConnections ({commit}, payload) {commit('setValidationCompanyConnections', payload)},
  updateValidationUs ({commit}, payload) {commit('setValidationUs', payload)},
  updateValidationContactUs ({commit}, payload) {commit('setValidationContactUs', payload)},
  updateValidationInsideRequest ({commit}, payload) {commit('setValidationInsideRequest', payload)},
  updateIsLogin: function({ commit }, payload) { commit('setIsLogin', payload ) },
  updateIsInAlert: function({ commit }, payload) { commit('setIsInAlert', payload ) },
  updateUserIdEncrypt: function ({commit}, payload) { commit('setUserIdEncrypt', payload) },
  updateUserType: function ({commit}, payload) { commit('setUserType', payload) },
  updateUserId({ commit }, payload) { commit('setUserId', payload) },
  updateMonitoredCompanies({ commit }, payload) { commit('setMonitoredCompanies', payload) },
  updateSelectedCompany({ commit }, payload) { commit('setSelectedCompany', payload) },
  updateLoader({ commit }, payload) { commit('setLoader', payload) },
  updateEmail({ commit }, payload) { commit('setEmail', payload) },
  updateSelectedLocation({ commit }, payload) { commit('setSelectedLocation', payload) },
  updateScreenOrientation({ commit }, payload) { commit('setScreenOrientation', payload) },
  updateShowPhonePrompt({ commit }, payload) { commit('setShowPhonePrompt', payload) },
  updateIsTouch({ commit }, payload) { commit('setIsTouch', payload) },
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
